<ng-template class="card ticket-list-item-container mb-4" #old>
  <div class="row">
    <div class="col-3 col-lg-2">
      <div *ngIf="ticket.Flag === ticketFlag.ACTIVE && transferWindowOpen" class="ticket-list-select-item-div text-center h-100">
        <input
          class="ticket-list-item-check-box"
          type="checkbox"
          id="selectTicket"
          name="selectTicket"
          (change)="toggleSelectTicket(ticket.Id)"
          [checked]="ticket.selected"
        />
        <div class="select-ticket">{{ 'fgbcl.ticket.list.item.select.ticket' | translate }}</div>
      </div>
      <div
        *ngIf="ticket.Flag !== ticketFlag.ACTIVE && transferWindowOpen"
        class="text-center bg-dark call-back-button h-100"
        (click)="open(callbackModal)"
      >
        <span class="material-icons align-middle ticket-list-item-icon" aria-hidden="">undo</span>
        <div class="ticket-list-item-icon-text">{{ 'fgbcl.ticket.list.item.call.back' | translate }}</div>
      </div>
      <div
        *ngIf="ticket.Flag === ticketFlag.ACTIVE && !transferWindowOpen"
        class="text-center bg-primary d-flex justify-content-center align-items-center h-100"
      >
        <span class="material-icons align-middle ticket-list-item-icon-no-text">credit_card</span>
      </div>
      <div *ngIf="ticket.Flag !== ticketFlag.ACTIVE && !transferWindowOpen" class="h-100 text-center bg-primary">
        <span class="material-icons align-middle ticket-list-item-icon">confirmation_number</span>
        <div class="ticket-list-item-icon-text">{{ 'fgbcl.ticket.list.item.transferred' | translate }}</div>
      </div>
    </div>
    <!-- Ticket Information -->
    <div class="col-9 col-lg-7">
      <div class="ticket-list-item">
        <div class="row">
          <div class="col-lg-4 col-12 card-number-div">
            <p class="ticket-status justify-content-around">
              <ng-container *ngIf="ticket.MediaType === 0">{{ 'fgbcl.ticket.list.item.card.no' | translate }}:</ng-container>
              <ng-container *ngIf="ticket.MediaType === 1">{{ 'fgbcl.ticket.list.item.ticket.no' | translate }}:</ng-container>
              <span class="text-primary ms-1">{{ ticket.ACN }}</span>
            </p>
            <p *ngIf="ticketColumn1 !== ticketDetails.Hide" class="d-none d-lg-block ticket-area mb-0 text-info">
              {{ 'fgbcl.ticket.list.item.area' | translate }}:
              <ng-container [ngSwitch]="ticketColumn1">
                <span *ngSwitchCase="ticketDetails.AreaLine1" class="text-primary">{{ ticket.AreaLine1 }}</span>
                <span *ngSwitchCase="ticketDetails.Stand" class="text-primary">{{ ticket.Stand }}</span>
                <span *ngSwitchCase="ticketDetails.StandName" class="text-primary">{{ ticket.StandName }}</span>
                <span *ngSwitchDefault class="text-primary">{{ ticket.Area }}</span>
              </ng-container>
            </p>
          </div>
          <div class="col-lg-8 col-12 justify-content-around status-div">
            <div
              *ngIf="
                ticket.Flag !== ticketFlag.ACTIVE && ticketFlag.TRANSFERRED === checkFlag(ticket.Flag, ticketFlag.TRANSFERRED)
              "
            >
              <p class="ticket-status">
                {{ 'fgbcl.ticket.list.item.status' | translate }}:<span class="text-primary ticket-item-email">
                  {{ 'fgbcl.ticket.list.item.transferred.to' | translate }} - {{ ticket.TransfereeEmailAddress }}
                </span>
              </p>
            </div>
            <div *ngIf="ticket.Flag === ticketFlag.ACTIVE" class="mb-4 mb-lg-0">
              <p class="ticket-status">
                {{ 'fgbcl.ticket.list.item.status' | translate }}:
                <span class="text-primary fw-bold">{{ 'fgbcl.ticket.list.item.available' | translate }}</span>
              </p>
            </div>
            <div class="d-none d-lg-block ps-0 col-8 col-lg-12">
              <div class="seat-details d-flex justify-content-between">
                <p *ngIf="ticketColumn2 !== ticketDetails.Hide" class="mb-0 text-info">
                  {{ 'fgbcl.ticket.list.item.table.section' | translate }}:
                  <ng-container [ngSwitch]="ticketColumn2">
                    <span *ngSwitchCase="ticketDetails.AreaLine1" class="text-primary">{{ ticket.AreaLine1 }}</span>
                    <span *ngSwitchCase="ticketDetails.Area" class="text-primary">{{ ticket.Area }}</span>
                    <span *ngSwitchCase="ticketDetails.StandName" class="text-primary">{{ ticket.StandName }}</span>
                    <span *ngSwitchDefault class="text-primary">{{ ticket.Stand }}</span>
                  </ng-container>
                </p>
                <p class="mb-0 text-info">
                  {{ 'fgbcl.ticket.list.item.table.row' | translate }}: <span class="text-primary">{{ ticket.Row }}</span>
                </p>
                <p class="mb-0 text-info">
                  {{ 'fgbcl.ticket.list.item.table.seat' | translate }}: <span class="text-primary">{{ ticket.Seat }}</span>
                </p>
              </div>
            </div>
            <!--Mobile rearranged divs -->
            <div *ngIf="ticketColumn1 !== ticketDetails.Hide" class="d-block d-lg-none ticket-area mb-1 text-info">
              {{ 'fgbcl.ticket.list.item.area' | translate }}:
              <ng-container [ngSwitch]="ticketColumn1">
                <span *ngSwitchCase="ticketDetails.AreaLine1">{{ ticket.AreaLine1 }}</span>
                <span *ngSwitchCase="ticketDetails.Stand">{{ ticket.Stand }}</span>
                <span *ngSwitchCase="ticketDetails.StandName">{{ ticket.StandName }}</span>
                <span *ngSwitchDefault>{{ ticket.Area }}</span>
              </ng-container>
            </div>
            <div *ngIf="ticketColumn2 !== ticketDetails.Hide" class="d-block d-lg-none mb-1">
              <p class="mb-0 text-info">
                {{ 'fgbcl.ticket.list.item.table.section' | translate }}:
                <ng-container [ngSwitch]="ticketColumn2">
                  <span *ngSwitchCase="ticketDetails.AreaLine1">{{ ticket.AreaLine1 }}</span>
                  <span *ngSwitchCase="ticketDetails.Area">{{ ticket.Area }}</span>
                  <span *ngSwitchCase="ticketDetails.StandName">{{ ticket.StandName }}</span>
                  <span *ngSwitchDefault>{{ ticket.Stand }}</span>
                </ng-container>
              </p>
            </div>
            <div class="d-flex d-lg-none ticket-transfer-mobile-ticket-item-seat-row">
              <p class="mb-0 text-info">
                {{ 'fgbcl.ticket.list.item.table.row' | translate }}: <span class="text-primary">{{ ticket.Row }}</span>
              </p>
              <p class="mb-0 text-info">
                {{ 'fgbcl.ticket.list.item.table.seat' | translate }}: <span class="text-primary">{{ ticket.Seat }}</span>
              </p>
            </div>
            <div
              class="more-actions d-flex d-lg-none fw-bold justify-content-center text-center text-primary mb-3"
              (click)="open(ticketHistoryModal)"
            >
              <span class="me-1 font-size-18 material-icons align-middle ticket-list-item-icon-tabs fw-bold">history</span>
              <p class="ticket-list-item-ticket-log-button-text mb-0">
                {{ 'fgbcl.ticket.list.item.ticket.history.expand.text' | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Toggle Ticket Transfer History -->
    <div class="col-lg-3 col-12">
      <div
        class="more-actions d-none d-lg-flex h-100 bg-muted text-center align-items-center fw-bold justify-content-center text-primary"
        (click)="open(ticketHistoryModal)"
      >
        <span class="material-icons align-middle ticket-list-item-icon-tabs font-size-18 fw-bold">history</span>
        <p class="mb-0 ms-1 font-size-11">{{ 'fgbcl.ticket.list.item.ticket.history.expand.text' | translate }}</p>
      </div>
    </div>
  </div>
</ng-template>

<div class="ticket-list-item">
  <div
    class="action-wrapper"
    *ngIf="ticket.Flag === ticketFlag.ACTIVE && transferWindowOpen"
    (click)="toggleSelectTicket(ticket.Id)"
  >
    <div class="form-check">
      <input class="form-check-input" type="checkbox" id="selectTicket" name="selectTicket" [checked]="ticket.selected" />
    </div>
  </div>
  <div class="ticket-info flex-column">
    @if (ticket.Flag === ticketFlag.ACTIVE && transferWindowOpen) {
      <div class="ticket-status-name d-lg-none d-flex">
        <span class="status-text open">{{ 'fgbcl.ticket.list.item.status.available' | translate }}</span>
      </div>
    } @else if (ticket.Flag !== ticketFlag.ACTIVE && ticketFlag.TRANSFERRED === checkFlag(ticket.Flag, ticketFlag.TRANSFERRED)) {
      <div class="ticket-transferred-info">
        <div class="ticket-transferred-label">
          {{ 'fgbcl.ticket.list.item.transferred.to' | translate }}
        </div>
        <div class="ticket-transferred-email">
          {{ ticket.TransfereeEmailAddress }}
        </div>
      </div>
    }
    <div class="ticket-list-item-details">
      <div class="ticket-list-item-detail-info">
        <div class="ticket-list-item-detail-label">
          <ng-container *ngIf="ticket.MediaType === 0">{{ 'fgbcl.ticket.list.item.card.no' | translate }}</ng-container>
          <ng-container *ngIf="ticket.MediaType === 1">{{ 'fgbcl.ticket.list.item.ticket.no' | translate }}:</ng-container>
        </div>
        <div class="ticket-list-item-detail-value">
          {{ ticket.ACN }}
        </div>
      </div>
      <div class="ticket-list-item-detail-info" *ngIf="ticketColumn1 !== ticketDetails.Hide">
        <div class="ticket-list-item-detail-label">{{ 'fgbcl.ticket.list.item.area' | translate }}</div>

        <div class="ticket-list-item-detail-value">
          @switch (ticketColumn1) {
            @case (ticketDetails.AreaLine1) {
              {{ ticket.AreaLine1 }}
            }
            @case (ticketDetails.Stand) {
              {{ ticket.Stand }}
            }
            @case (ticketDetails.StandName) {
              {{ ticket.StandName }}
            }
            @default {
              {{ ticket.Area }}
            }
          }
        </div>
      </div>
      <div class="ticket-list-item-detail-info" *ngIf="ticketColumn2 !== ticketDetails.Hide">
        <div class="ticket-list-item-detail-label">{{ 'fgbcl.ticket.list.item.table.section' | translate }}</div>
        <div class="ticket-list-item-detail-value">
          @switch (ticketColumn2) {
            @case (ticketDetails.AreaLine1) {
              {{ ticket.AreaLine1 }}
            }
            @case (ticketDetails.Area) {
              {{ ticket.Area }}
            }
            @case (ticketDetails.StandName) {
              {{ ticket.StandName }}
            }
            @default {
              {{ ticket.Stand }}
            }
          }
        </div>
      </div>
      <div class="ticket-list-item-detail-info d-lg-flex d-none" *ngIf="ticket.Row">
        <div class="ticket-list-item-detail-label">{{ 'fgbcl.ticket.list.item.table.row' | translate }}</div>
        <div class="ticket-list-item-detail-value">
          {{ ticket.Row }}
        </div>
      </div>
      <div class="d-flex">
        <div class="ticket-list-item-detail-info" *ngIf="ticket.Seat">
          <div class="ticket-list-item-detail-label">{{ 'fgbcl.ticket.list.item.table.seat' | translate }}</div>

          <div class="ticket-list-item-detail-value">
            {{ ticket.Seat }}
          </div>
        </div>

        <div class="ticket-list-item-detail-info d-lg-none d-flex ms-5" *ngIf="ticket.Row">
          <div class="ticket-list-item-detail-label">{{ 'fgbcl.ticket.list.item.table.row' | translate }}</div>
          <div class="ticket-list-item-detail-value">
            {{ ticket.Row }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="ticket-list-item-status">
    <button class="ticket-list-item-status-button" (click)="open(ticketHistoryModal)">
      <i class="material-icons ticket-info-icon">info</i>
    </button>
    @if (ticket.Flag === ticketFlag.ACTIVE && transferWindowOpen) {
      <span class="status-text open d-lg-flex d-none">{{ 'fgbcl.ticket.list.item.status.available' | translate }}</span>
    } @else if (ticket.Flag !== ticketFlag.ACTIVE && transferWindowOpen) {
      <button class="callback-button d-lg-flex d-none" (click)="open(callbackModal)">
        <i class="material-symbols-outlined">reply_all</i>
        <span>{{ 'fgbcl.ticket.list.item.callback.button' | translate }}</span>
      </button>
    }
  </div>
  @if (ticket.Flag !== ticketFlag.ACTIVE && transferWindowOpen) {
    <button class="callback-button d-lg-none d-flex" (click)="open(callbackModal)">
      <i class="material-symbols-outlined">reply_all</i>
      <span>{{ 'fgbcl.ticket.list.item.callback.button' | translate }}</span>
    </button>
  }
</div>

<!-- Modal -->
<ng-template #ticketHistoryModal let-modal>
  <div class="ticket-transfer-modal-header">
    <h5 class="ticket-transfer-modal-title">{{ 'fgbcl.ticket.log.modal.title' | translate }}</h5>
    <button type="button" class="close ticket-log-close-icon" aria-label="Close modal" (click)="modal.dismiss('Cross click')">
      <span class="material-icons align-middle">close</span>
    </button>
  </div>
  <div class="ticket-transfer-modal-body">
    <fgbcl-ticket-transfer-log
      [ticketColumn1]="ticketColumn1"
      [ticketColumn2]="ticketColumn2"
      [ticket]="ticket"
    ></fgbcl-ticket-transfer-log>
  </div>
</ng-template>

<ng-template #callbackModal let-modal>
  <div class="ticket-list-item-modal">
    <div class="ticket-transfer-modal-header">
      <h5 class="ticket-transfer-modal-title">
        {{ 'fgbcl.ticket.callback.modal.title' | translate }}
      </h5>
    </div>
    <div class="ticket-transfer-modal-body">
      <p>
        {{ 'fgbcl.ticket.transfer.callback.text' | translate }}
      </p>

      <fgbcl-selected-tickets-table
        [ticket]="ticket"
        [ticketColumn1]="ticketColumn1"
        [ticketColumn2]="ticketColumn2"
      ></fgbcl-selected-tickets-table>
      <fgbcl-errors></fgbcl-errors>
    </div>
    <div class="action-wrapper">
      <button class="cancel-btn btn text-danger" (click)="modal.dismiss('Cross click')" [disabled]="loading">
        {{ 'fgbcl.ticket.transfer.callback.cancel.button' | translate }}
      </button>
      <button (click)="callbackTicket()" class="callback-btn btn btn-success" [disabled]="loading">
        <span *ngIf="!loading">{{ 'fgbcl.ticket.transfer.callback.confirm.button' | translate }}</span>
        <span *ngIf="loading"><fgbcl-loading [size]="'small'"></fgbcl-loading></span>
      </button>
    </div>
  </div>
</ng-template>
